import { i18n } from '@lingui/core';
import { type AppLocale } from 'app-shared/types';

import { clerkBaseLocalizationState } from '@/auth/clerk/states/clerkBaseLocalizationState';
import { loadClerkBaseLocalization } from '@/auth/clerk/utils/loadClerkBaseLocalization';
import { AUTH_MODE } from '@/auth/constants/AuthMode';
import { jotaiStore } from '@/ui/utilities/state/jotai/jotaiStore';

// Only the active language is downloaded. With Clerk sign-in, Clerk's own
// translation downloads at the same time, so its screens switch language
// together with ours.
export const activateLocale = async (locale: AppLocale) => {
  const [{ messages }, clerkBaseLocalization] = await Promise.all([
    import(`~/locales/generated/${locale}.ts`),
    AUTH_MODE === 'clerk' ? loadClerkBaseLocalization(locale) : undefined,
  ]);

  jotaiStore.set(clerkBaseLocalizationState.atom, clerkBaseLocalization);
  i18n.load(locale, messages);
  i18n.activate(locale);
  document.documentElement.lang = locale;
};
